const getAll = ({ materialType, module, language, limit, offset }) => (
  fetch(`${process.env.VUE_APP_API_URL}/document-selection/${module}/${materialType}/${language}?limit=${limit}&offset=${offset}`, { credentials: 'include' })
    .then(response => {
      return response.text()
        .then(text => {
          if (!response.ok) {
            return Promise.reject(response.statusText)
          }
          const data = text && JSON.parse(text)
          return data
        })
    })
)

const getCount = ({ materialType, module, language }) => (
  fetch(`${process.env.VUE_APP_API_URL}/document-selection/${module}/${materialType}/${language}/count`, { credentials: 'include' })
    .then(response => {
      return response.text()
        .then(text => {
          if (!response.ok) {
            return Promise.reject(response.statusText)
          }
          const data = text && JSON.parse(text)
          return data
        })
    })
)

const updateSelectedByEditor = ({ module, materialType, documentKey, language, selectedByEditor }) => (
  fetch(`${process.env.VUE_APP_API_URL}/document-selection/${module}/${materialType}/${documentKey}/${language}/selected-by-editor`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ selectedByEditor }),
    credentials: 'include'
  }).then(response => {
    return response.text()
      .then(text => {
        const data = text && JSON.parse(text)
        if (!response.ok) {
          return Promise.reject(response.statusText)
        }
        return data
      })
  })
)

export default {
  getAll,
  getCount,
  updateSelectedByEditor
}
